<div class="space-y-8">
    <h2 class="mb-12 text-center">
        See what others <span class="text-red">say</span>
    </h2>
    <div class="mx-auto max-w-5xl">
        @defer {
            <app-trustpilot-badge></app-trustpilot-badge>
        }
    </div>
</div>
